import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../../../Common/DataTable';
import {
  DeleteUnitPayload, DriverExpensePayload, UnitListingData,
  UnitToTestProp,
  UpdatedBidDetailsValues,
} from '../../utils/types';
import { UnitListingColumns } from '../../utils/constants';
import EndPoints from '../../../../../Routes/EndPoints';
import { RootState } from '../../../../../redux/rootState';
import {
  deleteUnitStart, getAssociatedUnitsStart, getBidByIdStart, getDriverExpenseStart, resetAssociatedUnits,
  setIsBidPricingUpdated,
  setUpdatedBidDetailsValues,
} from '../../redux/bidWorksheetSlice';
import { assignBidPricing, formatUnitListingData } from '../../utils/helper';
import { AddUnitModal } from './addUnitModal';
import ComponentDeleteModal from '../../../../../Common/DeleteModal/ComponentDeleteModal';
import ComponentConfirmModal from '../../../../../Common/UnitSelectorConfirmationModal/UnitConfirmationModal';
import ReOrderUnitsModal from '../../../../ComponentNavBar/ReOrderUnitsModal';
import BidByJobModal from '../../../../ComponentNavBar/BidByJobModal';
// import { ConfirmationIcon } from '../../../../../assets/Icons/AnalystIcons/ConfirmationIcon';
// import DualConfirmationModal from '../../../../../Common/ConfirmationModal/DualConfirmationModal';
// import JobsListModal from '../../../../ComponentNavBar/JobsListModal';

function ComponentUnitToTest({ watch, setValue }:UnitToTestProp) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [openReorderModal, setOpenReorderModal] = useState(false);
  // const [openConfirmMethod, setOpenConfirmMethod] = useState(false);
  // const [showJobsListModal, setShowJobsListModal] = useState(false);
  const [openMoveModal, setOpenMoveModal] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const navigate = useNavigate();
  const {
    bidId, unitList, totalUnits, updatedBidDetails, selectedBid, isBidPricingUpdated,
  } = useSelector((state:RootState) => state.bidsReducer);
  const {
    selectedJob,
  } = useSelector((state:RootState) => state.jobStarterReducer);

  const dispatch = useDispatch();
  const bidPricingValues = watch();

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    return () => {
      dispatch(resetAssociatedUnits());
    };
  }, []);

  const handleData = () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      bidId,
    };

    dispatch(getAssociatedUnitsStart(payload));
  };
  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const handleButtonClick = () => {
    if (Object.keys(updatedBidDetails)?.length > 0 || isBidPricingUpdated) {
      setShowConfirmModal(true);
    } else {
      setShowModal(true);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDelete = (unitId:string) => {
    setSelectedId(unitId);
    setDeleteModal(true);
  };
  const handleMoveUnit = (unitId:string) => {
    setSelectedId(unitId);
    setOpenMoveModal(selectedJob?.JobInfo?.JobId || '');
    // setOpenConfirmMethod(true);
  };
  // const handleWithinSameJob = () => {
  //   setOpenMoveModal(selectedJob?.JobInfo?.JobId || '');
  //   setOpenConfirmMethod(false);
  // };
  // const handleInAnotherJob = () => {
  //   setShowJobsListModal(true);
  //   setOpenConfirmMethod(false);
  // };
  const handleDeleteModal = () => {
    const payload:DeleteUnitPayload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      unitId: selectedId,
      bidId,
    };
    dispatch(deleteUnitStart(payload));
    setDeleteModal(false);
  };

  const handleEdit = (unitId:string) => {
    navigate(`${EndPoints.UNIT}/${unitId}`);
  };

  // const handleSave = () => {
  //   const bidPayload = selectedBid?.BidDetails;
  //   const bidPricingPayload = constructBidPricingPayload(bidPricingValues);
  //   const payload: UpdateBidPayload = {
  //     BidId: bidId,
  //     BidDetails: { ...bidPayload, JobId: selectedBid?.BidDetails.JobId },
  //     BidPriceDetails: bidPricingPayload,
  //   };
  //   dispatch(updateBidStart(payload));
  // };
  useEffect(() => {
    if (selectedJob?.JobInfo?.SiteId) {
      let round = 0;
      let gulf = false;
      let nyc = false;
      if (Object.keys(updatedBidDetails).length > 0) {
        round = updatedBidDetails.roundTripMiles;
        gulf = updatedBidDetails.gulfCoastFL;
        nyc = updatedBidDetails.nyc;
      } else {
        round = selectedBid?.BidDetails?.RoundTripMiles || 0;
        gulf = selectedBid?.BidDetails?.GulfCoastFL || false;
        nyc = selectedBid?.BidPriceDetails?.IsNyc || false;
      }
      const IsBidNonMinimum = selectedBid?.BidDetails?.IsBidNonMinimum;
      const payload:DriverExpensePayload = {
        roundTripMiles: round || 0,
        calculatedDays: Number(bidPricingValues?.calculatedDays) || 0,
        overridedays: Number(bidPricingValues?.overRideDays) || 0,
        siteId: selectedJob?.JobInfo?.SiteId,
        gulfCoastFL: gulf || false,
        isNyc: nyc || false,
        airfare: Number(bidPricingValues?.airfare) || 0,
        nonProdDays: Number(bidPricingValues?.nonProdDays) || 0,
      };
      const payload2 = { ...payload, IsBidNonMinimum };

      dispatch(getDriverExpenseStart(selectedBid?.BidId ? payload2 : payload));
    }
  }, [bidPricingValues?.airfare, bidPricingValues?.nonProdDays]);

  const handleReload = () => {
    dispatch(setUpdatedBidDetailsValues({} as UpdatedBidDetailsValues));
    dispatch(setIsBidPricingUpdated(false));
    assignBidPricing(setValue, selectedBid);
    setShowConfirmModal(false);
    setShowModal(true);
  };

  const moveSuccessRun = () => {
    dispatch(getBidByIdStart(String(bidId)));
    handleData();
  };

  return (
    <>
      <DataTable<UnitListingData>
        handleButtonClick={handleButtonClick}
        data={formatUnitListingData(unitList) || []}
        columns={UnitListingColumns}
        totalRecords={totalUnits}
        buttonText="Add Unit"
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleData={handleData}
        handleMoveUnit={handleMoveUnit}
        buttonNameFifth={unitList?.length > 1 ? 'Re-order list' : ''}
        handleButtonClickFifth={() => setOpenReorderModal(true)}
        manualPageSize
        manualPageSizeValue={200}
        handleDataFromComponent
      />
      {showModal && <AddUnitModal handleClose={handleClose} showModal={showModal} watch={watch} />}
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setDeleteModal(false)}
        handleDelete={handleDeleteModal}
      />
      <ComponentConfirmModal
        show={showConfirmModal}
        setOpenFrom={() => setShowConfirmModal(false)}
        handleClick={handleReload}
      />
      {openReorderModal && (
      <ReOrderUnitsModal
        open={openReorderModal}
        handleClose={() => setOpenReorderModal(false)}
        handleData={handleData}
      />
      )}
      <br />
      {/* {openConfirmMethod && (
      <DualConfirmationModal
        show={openConfirmMethod}
        setOpenFrom={() => { setOpenConfirmMethod(false); setSelectedId(''); }}
        proceedBtnText="Within same Job"
        proceedBtnText2="In another Job"
        handleConfirmation={handleWithinSameJob}
        handleConfirmation2={handleInAnotherJob}
        confirmationIcon={<ConfirmationIcon />}
        text="How would you like to proceed the movement of the selected unit?"
      />
      )} */}
      {/* {showJobsListModal && (
      <JobsListModal
        open={showJobsListModal}
        handleClose={() => setShowJobsListModal(false)}
        selectedUnit={selectedId}
        handleSuccess={moveSuccessRun}
      />
      )} */}
      {openMoveModal?.length > 0 && (
      <BidByJobModal
        open={openMoveModal}
        handleClose={() => setOpenMoveModal('')}
        selectedUnit={selectedId}
        handleSuccess={moveSuccessRun}
      />
      )}
      {/* <Grid item xs={12} sm={12} md={12}>
        <div className="save_and_next_div">
          <Button type="submit" className="button_save_and_next" onClick={handleSave}>Save</Button>
        </div>
      </Grid> */}
    </>
  );
}
export default ComponentUnitToTest;
